import type { RegistrationExtendedFormValues } from "@buxus/shared";

type Props = {
  extendedForm: RegistrationExtendedFormValues;
  onPatch: (partial: Partial<RegistrationExtendedFormValues>) => void;
};

export function MutualAidStep({ extendedForm, onPatch }: Props) {
  return (
    <>
      <h2 className="reg-step-title">Agency Mutual Aid Agreements</h2>
      <div className="reg-grid">
        <label className="reg-checkbox-label reg-field--full">
          <input
            type="checkbox"
            checked={extendedForm.mutualAidAgreements}
            onChange={(e) => onPatch({ mutualAidAgreements: e.target.checked })}
          />
          <span>Mutual aid agreements with any agencies</span>
        </label>
        <label className="reg-field">
          <span>With Whom?</span>
          <input
            value={extendedForm.withWhom}
            onChange={(e) => onPatch({ withWhom: e.target.value })}
          />
        </label>
      </div>
    </>
  );
}
